/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersCreateFromEmailInvite } from '../../models/members-create-from-email-invite';
import { MembersInviteSuppliers } from '../../models/members-invite-suppliers';

export interface InviteSuppliersApiV2MembersSuppliersPost$Params {
  org: string;
      body: Array<MembersCreateFromEmailInvite>
}

export function inviteSuppliersApiV2MembersSuppliersPost(http: HttpClient, rootUrl: string, params: InviteSuppliersApiV2MembersSuppliersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersInviteSuppliers>> {
  const rb = new RequestBuilder(rootUrl, inviteSuppliersApiV2MembersSuppliersPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersInviteSuppliers>;
    })
  );
}

inviteSuppliersApiV2MembersSuppliersPost.PATH = '/api/v2/members/suppliers';
